import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import moment from 'moment'
import { translateToFrench } from '../translations'

export const LetterRow = ({ letter }) => {
  return (
    <TableRow key={letter.id}>
      <TableCell component="th" scope="row">
        {letter.recipientName}
      </TableCell>
      <TableCell component="th" scope="row">
        {letter.condoName}
      </TableCell>
      <TableCell>{letter.recipientAddress}</TableCell>
      <TableCell>{moment(letter.createdAt).format('DD/MM/YY')}</TableCell>
      <TableCell>{translateToFrench(letter.status)}</TableCell>
      <TableCell>
        {letter.signingProof && (
          <a href={letter.signingProof} rel="noreferrer" target="_blank">
            voir
          </a>
        )}
      </TableCell>
      <TableCell>
        {letter.sendingProof && (
          <a href={letter.sendingProof} rel="noreferrer" target="_blank">
            voir
          </a>
        )}
      </TableCell>
      <TableCell>
        <a href={letter.letter} rel="noreferrer" target="_blank">
          voir
        </a>
      </TableCell>
    </TableRow>
  )
}
